import { CommonMessages } from 'src/messages/validationMessages';
import { EMAIL_REGEX, REFERRAL_LENGTH } from 'src/utils/constants';
import * as Yup from 'yup';
import { phoneField } from './phoneSchema';

export const buildSignupSchema = (countryCode?: string) => Yup.object().shape({
    name: Yup.string().required(CommonMessages.name_required),
    phone: phoneField(countryCode),
    email: Yup.string()
        .matches(EMAIL_REGEX, CommonMessages.email_invalid)
        .required(CommonMessages.email_required),

    referralCode: Yup.string().test(CommonMessages.referral_valid, CommonMessages.referral_invalid, function (value) {
        if (value && value.length >= REFERRAL_LENGTH) {
            return true
        } else {
            if (!value) {
                return true
            }
        }

    }),
    receivesms: Yup.boolean()
    .oneOf([true], CommonMessages.otp_check_required)
});

/** @deprecated Use buildSignupSchema(getActiveCountryCode()) for country-aware validation. */
export const SignupSchema = buildSignupSchema();
